interface AgentRunErrorBannerProps {
  message: string | null;
}

/** The last run's failure, under the turn that failed, where the reader is already looking. */
export function AgentRunErrorBanner({ message }: AgentRunErrorBannerProps) {
  if (message === null) return null;
  return <p className="pa-error" role="alert">{message}</p>;
}
